// extracted by mini-css-extract-plugin
export default {"paginatedTable":"PaginatedTable_paginatedTable__w8clT","filterBtnWrapper":"PaginatedTable_filterBtnWrapper__B6Gw2"};